import {UIButton, UIControl, _CAAnimationType,_CAClassListForAnimationType, UIViewControllerTransitioningDelegate} from "uikit";
import {UILabel} from "uikit";
import {UIViewController} from "uikit";
import {DLDB} from "dldb";
import {MIOStringWithFormat} from "mio-core";
import {NSLocalizeString, NSObject } from "foundation";

export class BookingPaxNoticeViewController extends UIViewController
{

    private bookingMaxPaxLabel:UILabel = null;
    private bookingContactLabel:UILabel = null;
    private goBackButton:UIButton;


    viewDidLoad() {
        super.viewDidLoad();

        if (this.bookingMaxPaxLabel) this.bookingMaxPaxLabel.text = MIOStringWithFormat(
            NSLocalizeString("NOTICE MAX PAX MESSAGE", "NOTICE MAX PAX MESSAGE"), this._maxPax );

        if (this.bookingContactLabel) this.bookingContactLabel.text = MIOStringWithFormat(
            NSLocalizeString("NOTICE MAX PAX CONTACT", "NOTICE MAX PAX CONTACT"));

        if (this.goBackButton) this.goBackButton.addTarget(this, this.onGoBack, UIControl.Event.touchUpInside);
   
        // Get company email and phone for message
        DLDB.shared.company((code: number, response: any) => {
            if (code === 200 && response.data != null) {
                this.setRestaurantContactData(response.data.phone.number || "CONFIG_PHONE", response.data.email || "CONFIG_EMAIL");
            }
        });
    }


    private setRestaurantContactData = (phone: string, email: string) => {
        if (this.bookingContactLabel) this.bookingContactLabel.text = MIOStringWithFormat(
            NSLocalizeString("NOTICE MAX PAX CONTACT", "NOTICE MAX PAX CONTACT"), email, email, phone );
    }

    private _maxPax:number|null = null;
    set maxPax ( i:number ) {
      this._maxPax = i;
    }

    private onGoBack() {
        this.dismissViewController(true); 
    }


}